<h1 mat-dialog-title>
  <p>{{ 'users.policyGroups.selectACamera' | t }}</p>
  <form class="search-bar" (ngSubmit)="submitForm()">
    <input placeholder="{{ 'common.search' | t }}" [formControl]="searchControl" />
    <button
      mat-icon-button
      icon="search"
      type="submit"
      matTooltip="{{ 'common.search' | t }}"
      class="sn-searchbar__search-button searchBtn"
    >
      <mat-icon>search</mat-icon>
    </button>
    <button
      mat-icon-button
      icon="close"
      matTooltip="{{ 'common.clearSearch' | t }}"
      class="sn-searchbar__clear-button closeBtn"
      (click)="clear()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </form>
</h1>
<mat-dialog-content>
  <sn-data-list #list reloadByQueryParams [fetchFn]="loadData">
    <sn-infinite-scroll>
      <sn-pull-to-refresh>
        <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="listTmpl"></ng-template>
        <ng-template
          [ngIf]="!list.dataSource.data.length && list.dataIsInited"
          [ngIfThen]="emptyTmpl"
        ></ng-template>
      </sn-pull-to-refresh>
    </sn-infinite-scroll>
  </sn-data-list>
</mat-dialog-content>
<mat-dialog-actions snButtonGroup>
  <button mat-button color="danger" (click)="cancel()">{{ 'common.cancel' | t }}</button>
</mat-dialog-actions>

<ng-template #listTmpl>
  <mat-table [dataSource]="list.dataSource.data">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>{{ 'common.name' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let camera">
        {{ camera.name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="location">
      <mat-header-cell *matHeaderCellDef>{{ 'common.location' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let camera">
        {{ camera.location ? camera.location.name : ('common.notSpecified' | t) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="floor">
      <mat-header-cell *matHeaderCellDef>{{ 'common.floor' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let camera">
        {{ camera.floor ? camera.floor.name : ('common.notSpecified' | t) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="owner">
      <mat-header-cell *matHeaderCellDef>{{ 'common.owner' | t }}</mat-header-cell>
      <mat-cell *matCellDef="let item">
        <sn-object-owner [object]="item"></sn-object-owner>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row (click)="onSelected(camera)" *matRowDef="let camera; columns: columns"> </mat-row>
  </mat-table>
</ng-template>

<ng-template #emptyTmpl>
  <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
    {{ 'common.noResultsMatchSearch' | t }}
  </sn-empty-state>
</ng-template>
